$('.single-slider .slide-list').slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 1,
  adaptiveHeight: true,
  arrows:true,
  navigation : true,
});

$(document).ready(function() { 
  $('body').find('.single-slider .slick-prev').text('Prev');
  $('body').find('.single-slider .slick-next').text('Next');
});  

$('.review-section-main .review-main-itam').slick({
  dots: true,
  infinite: true,
  speed: 600,
  slidesToShow: 2,
  slidesToScroll: 1,
  arrows:false,
  responsive: [

    {
      breakpoint: 840,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
